<!--
 * @Description: 
 * @Author: huangshiwen
 * @Date: 2022-06-06 13:54:29
 * @LastEditTime: 2022-06-27 17:14:13
-->
<template>
  <div class="login-wrap" ref="editorDOM">
    <div class="temp-box">
    <img class="img" src="../images/bg.jpg" alt="">
    <div class="login-form">
      <div class="bg-box"></div>
      <div class="real-box">
        <h2>修改密码</h2>
        <div class="usually-box user-wrap">
          <label>输入原密码</label>
          <input v-model="oldPassword" type="password" placeholder="8-20位字母、数字结合">
        </div>
        <div class="usually-box password-wrap">
          <label>输入新密码</label>
          <input v-model="newPassword" type="password" placeholder="8-20位字母、数字结合">
        </div>
        <div class="usually-box two-password-wrap">
          <label>再次输入密码</label>
          <input v-model="twoNewPassword" type="password" placeholder="8-20位字母、数字结合">
        </div>
        <div class="login-btn" @click="sendPost">
          <img src="../images/login-img2.png" alt=""><span>提交</span> 
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { JSEncrypt } from 'jsencrypt';
export default {
  name: "updatePassword-001",
  data() {
    return {
        userId: "",
        oldPassword: "",
        newPassword: "",
        twoNewPassword: "",
      }
  },
  created() {
    this.checkLoginStatus();
    this.getPublicKey();
  },
  mounted() {
    
  },
  methods: {
    // 检查是否登录
    checkLoginStatus(){
      let ut = localStorage.getItem('ut');
      // localStorage中没有ut，判断是否登录
      if(ut == undefined || ut == null || ut == ""){
        this.$router.push(
            "/personalCenter/login"
        );
      }
    },
    // 获取公匙
    getPublicKey() {
      this.$API.rsaPublic().then(res => {
        if(res.code == 0) {
          this.publicKey = res.data;
        }else {
          this.$message.error(res.msg);
        }
      });
    },
    // 加密
    setEncrypt(msg) {
      let jsencrypt = new JSEncrypt({});
      jsencrypt.setPublicKey(this.publicKey);
      return jsencrypt.encrypt(msg);
    },
    // 发送请求
    sendPost() {
      if(!this.oldPassword) {
        this.$message.warning("请输入旧密码");
        return
      }
      if(!this.newPassword) {
        this.$message.warning("请输入密码");
        return
      }
      let reg = /(?!^\d+$)(?!^[a-zA-Z]+$)[0-9a-zA-Z]{8,20}/;
      if(!reg.test(this.newPassword)) {
        return this.$message.warning("请输入8-20位字母，数字结合的密码");
      }
      if(!this.twoNewPassword) {
        this.$message.warning("请再次输入密码");
        return
      }
      if(this.newPassword !== this.twoNewPassword) {
        this.$message.warning("两次输入密码不一致");
        return
      }
      // this.oldPassword = this.setEncrypt(this.oldPassword);
      // this.newPassword = this.setEncrypt(this.newPassword);
      let oldPassword = this.setEncrypt(this.oldPassword);
      let newPassword = this.setEncrypt(this.newPassword);
      let obj = {
        sys: "BOEH",
        oldPc: oldPassword,
        newPc: newPassword,
        encryptMode: 'RSA'
      }
      this.$API.modifyPc(obj).then(res => {
        if(res.code == 0) {
          this.$message.success('修改密码成功！');
          localStorage.removeItem("userId");
          localStorage.removeItem("ut");
          this.$router.push('/personalCenter/login');
        }else {
          this.$message.error(res.msg);
        }
      });
    },
  }
};
</script>

<style lang="less" scoped>
.m-screen-pc {
    position: relative;
    width: 100%;
    height: 600px;
    .temp-box {
      position: relative;
      width: 100%;
      // height: 600px;
      min-height: 945px;
    }
    .img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    .login-form {
      position: absolute;
      top: 20%;
      right: 5%;
      padding: 50px 44px;
      width: 465px;
      height: 460px;
    }
    .bg-box {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #fff;
      opacity: 0.5;
      z-index: 1;
    }
    .real-box {
      position: relative;
      z-index: 2;
    }
    h2 {
      text-align: center;
      font-size: 30px;
      margin-bottom: 12px;
    }
    .usually-box {
      border: 1px solid #fff;
      padding: 12px 14px;
      position: relative;
      margin-bottom: 15px;
      &::after {
        display: block;
        content: "";
        overflow: hidden;
        visibility: hidden;
        clear: both;
      }
      label {
        float: left;
        width: 100px;
        margin-right: 10px;
        font-size: 16px;
        position: relative;
        top: -4px;
      }
      input {
        float: left;
        font: inherit;
        outline: 0;
        border: 0;
        width: 235px;
        background: none;
        background-color: rgb(232, 240, 254);
        background-image: none !important;
      }
    }
    .yz-wrap {
      input {
        background-color: transparent;
        width: 170px;
      }
      #yzm {
        position: absolute;
        top: 0;
        right: 0;
        width: 110px;
        height: 50px;
        background: #fff;
        border: 0;
      }
    }
    .login-btn {
      position: relative;
      margin-top: 32px;
      height: 54px;
      line-height: 54px;
      background: #0078d4;
      color: #fff;
      border-radius: 50px;
      text-align: center;
      img {
        position: absolute;
        top: 10px;
        left: 140px;
      }
      span {
        font-size: 16px;
      }
    }
    .txt {
      margin-top: 12px;
      display: flex;
      justify-content: space-between;
      a {
        color: #333;
      }
    }
}

.m-screen-mobile {
    position: relative;
    width: 100%;
    height: 400px;
     .temp-box {
      position: relative;
      width: 100%;
      height: 9rem;
    }
    .img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    .login-form {
      position: relative;
      margin: 0.3rem auto;
      padding: 0.6rem 0.4rem;
      width: 90%;
      height: 80%;
    }
    .bg-box {
      position: absolute;
      top: 10px;
      left: 0;
      width: 100%;
      height: 100%;
      background: #fff;
      opacity: 0.5;
      z-index: 1;
    }
    .real-box {
      position: relative;
      z-index: 2;
    }
    h2 {
      text-align: center;
      font-size: 0.4rem;
      margin-bottom: 0.15rem;
    }
    .usually-box {
      border: 1px solid #fff;
      padding: 0.15rem 0.2rem;
      position: relative;
      margin-bottom: 0.2rem;
      &::after {
        display: block;
        content: "";
        overflow: hidden;
        visibility: hidden;
        clear: both;
      }
      label {
        float: left;
        width: 44%;
        margin-right: 10px;
        font-size: 16px;
        position: relative;
        top: -4px;
      }
      input {
        float: left;
        font: inherit;
        outline: 0;
        border: 0;
        width: 50%;
        background: none;
        background-color: rgb(232, 240, 254);
        background-image: none !important;
        font-size: 16px;
      }
    }
    .yz-wrap {
      input {
        background-color: transparent;
        width: 40%;
      }
      #yzm {
        position: absolute;
        top: 0;
        right: 0;
        width: 110px;
        height: 100%;
        background: #fff;
        border: 0;
      }
    }
    .login-btn {
      position: relative;
      margin-top: 0.1rem;
      height: 1rem;
      line-height: 1rem;
      background: #0078d4;
      color: #fff;
      border-radius: 50px;
      text-align: center;
      img {
        position: absolute;
        top: 0.1rem;
        left: 1.3rem;
      }
      span {
        font-size: 16px;
      }
    }
    .txt {
      margin-top: 12px;
      display: flex;
      justify-content: space-between;
      a {
        color: #333;
      }
    }
}
</style>
